export const COLORS = {
	/*
    BG_COLOR: 'rgb(250,250,250)',
    BORDER_COLOR: 'rgba(0,0,0,.095)',
    BORDER_COLOR_DARK: 'rgba(0,0,0,.11)',
    EXPANSION_PANEL_BGCOLOR: 'rgba(0,0,0,.01)',
    FOOTER_BGCOLOR: 'rgb(254,254,254)',
    ICON_COLOR: 'rgb(117,117,117)',
    PAPER_COLOR: 'rgb(255,255,255)',
    PAPER_BOX_SHADOW:
        '0 2px 3px 0 rgba(0,0,0,.015), 0 1px 5px 0 rgba(0,0,0,.025)',
    CIRC_PROGRESS_COLOR: 'rgba(0,0,0,0.6)',
    HYPERLINK_COLOR_HEX: '#505050',
    */
	/*
    COLOR_GREEN_1: 'rgb(84,185,72)',
    COLOR_GREEN_2: 'rgb(48,153,64)',
    COLOR_GREEN_2_HEX: '#309940',
    COLOR_GREY_1: 'rgb(210,210,210)',
    COLOR_GREY_2: 'rgb(164,164,164)',
    COLOR_GREY_3: 'rgb(90,90,90)',
    COLOR_GREY_4: 'rgb(48,51,57)',
    COLOR_WHITE: 'rgb(255,255,255)',
    COLOR_WHITE_2: 'rgb(245,245,245)',
    COLOR_WHITE_3: 'rgb(240,240,240)',
    COLOR_BLACK: 'rgb(0,0,0)',
    COLOR_BLUE: 'rgb(44,89,133)',
    COLOR_LIGHT_BLUE: 'rgb(91,143,203)',
    */

	PRIMARY: 'rgb(255, 121, 32)',
	PRIMARY__HEX: '#F58134',
	PRIMARY2: 'rgb(183,188,193)',
	SECONDARY: 'rgb(44,76,84)',
	SECONDARY__HEX: '#2C4C54',
	SECONDARY2: 'rgb(104,130,147)',
	LINK: 'rgb(0,105,147)',
	LINK__HEX: '#006993',
	BORDER: 'rgb(238,238,238)',
	BORDER_BUTTON_DEFAULT: 'rgb(212,212,212)',
	BACKGROUND_INPUT: 'rgb(243,244,245)',
	BACKGROUND_INPUT_HOVER: 'rgb(232,232,232)',
	BACKGROUND: 'rgb(250,250,250)',
	BACKGROUND_GREY_DARK: 'rgb(77,85,85)',
	BACKGROUND_GREY_LIGHT: 'rgb(240,240,240)',
	TEXT_SECONDARY: 'rgba(0,0,0,.6)',
	GUMETAL: 'rgb(29, 53, 70)'
};

export const DIMENSIONS = {
	CARD_HEADER_HEIGHT: 60,
	DISTRIBUTION_CHART_HEIGHT: 135,
	DRAWER_WIDTH: 290,
	FILTER_BUTTON_HEIGTH: 38,
	NAVBAR_HEIGHT: 44,
	NAVBAR_HEIGHT_XS: 38,
	SELECT_MENU_ITEM_HEIGHT: 36,
	SIDEPANEL_WIDTH: 290,
	SIDEPANEL_WIDTH_SM: 260,
	SEARCH_HEIGHT: 48,
	SKELETON_BUTTON_WIDTH: 130,
	SKELETON_BUTTON_HEIGHT: 44,
	SKELETON_TABLE_ROW_HEIGHT: 80,
	SKELETON_TEXT_HEIGHT: 30,
	SKELETON_TITLE_HEIGHT: 38,
	TABBAR_HEIGHT: 52,
	TABBAR_HEIGHT_XS: 46
};

export const FONT_FAMILIES = ['Inter', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(',');

export const FONT_SIZES = {
	H1: '2.5rem', // 40px
	H2: '2.125rem', // 34px
	H3: '1.875rem', // 30px
	H4: '1.675rem', // 26px
	H5: '1.375rem', // 22px
	H6: '1.125rem', // 18px
	SUBTITLE1: '1rem', // 16px
	SUBTITLE2: '0.938rem', // 15px
	BODY1: '0.875rem', // 14px
	BODY2: '0.813rem', // 13px
	CAPTION: '0.75rem' // 11px
};

export const CN_FONT_SIZES = {
	H1: '3.325rem', // 40px
	H2: '2.826rem', // 34px
	H3: '2.493rem', // 30px
	H4: '2.227rem', // 26px
	H5: '1.828rem', // 22px
	H6: '1.496rem', // 18px
	SUBTITLE1: '1.33rem', // 16px
	SUBTITLE2: '1.247rem', // 15px
	BODY1: '1.163rem', // 14px
	BODY2: '1.081rem', // 13px
	CAPTION: '0.997rem' // 11px
};

export const NUMBER_OF_SKELETON_TABLE_ROWS = 8;
